import React from 'react'
import classnames from 'classnames'
import Spinner from './Spinner'
import HTMLText from './HTMLText'
import get from 'lodash/get'

import '../styles/form.scss'

function FormSocialButton({
  provider,
  label,
  className,
  classNameLabel,
  classNameButton,
  isSettings,
  loading,
  error,
  authorization,
  appleAuthorizationName,
  onAuthorizeClick = () => {},
  onUnauthorizeClick = () => {},
  ...props
}) {
  if (!authorization) {
    props.onClick = onAuthorizeClick
  }
  return (
    <div className={classnames('account-form', 'account-form--social', className)}>
      <div className="account-form__container">
        <span
          className={classnames(
            'account-form__label',
            { 'account-form__label--settings': isSettings },
            classNameLabel
          )}>
          {label}
        </span>
        {React.createElement(authorization ? 'div' : 'button', {
          ...props,
          className: classnames(
            'account-form__via-social',
            `account-form__via-social--${provider}`,
            { 'account-form__via-social--have-authorization': Boolean(authorization) },
            classNameButton
          ),
          children: Boolean(authorization) ? (
            <>
              {provider === 'apple'
                ? appleAuthorizationName
                  ? appleAuthorizationName
                  : 'Связано с Apple ID'
                : authorization}
              <button
                className={classnames('account-form__via-social__close-button', {
                  'account-form__via-social__close-button--loading': loading
                })}
                onClick={onUnauthorizeClick}
                disabled={loading}>
                {loading && <Spinner isSmall />}
              </button>
            </>
          ) : loading ? (
            <Spinner isWhite />
          ) : (
            'Привязать'
          )
        })}
      </div>
      {error && (
        <div className="account-form__error account-form__error--input account-form__error--settings">
          <HTMLText html={get(error, 'message') ? get(error, 'message') : error} />
        </div>
      )}
    </div>
  )
}

export default FormSocialButton
